import React, { PropsWithChildren } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

export interface TableProviderProps {}

export const TableProvider = (props: PropsWithChildren<TableProviderProps>) => {
  return <DndProvider backend={HTML5Backend}>{props.children}</DndProvider>;
};
